import React from 'react';
import type {} from '@jobseeker/lotus/mui.types';
import Contacts from '@jobseeker/lotus/components/Contacts';
import {Box} from '@mui/material';
import {useSelector} from 'react-redux';
import type {AppState} from '@jobseeker/common-core/types';

const ContactSection = () => {
  const {
    timelines: {
      config: {contactData},
    },
  } = useSelector((state: AppState) => state.competition);
  return (
    <Box id="contact" sx={{marginBottom: 4, background: 'none'}}>
      <Contacts contactData={contactData} />
    </Box>
  );
};

export default ContactSection;
